"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformType = void 0;
// Types de plateforme (utilisé pour analytics, device info, etc.)
var PlatformType;
(function (PlatformType) {
    PlatformType["Mobile"] = "Mobile";
    PlatformType["Booth"] = "Booth";
    PlatformType["Desktop"] = "Desktop";
    PlatformType["Web"] = "Web";
    PlatformType["Dedicated"] = "Dedicated";
})(PlatformType || (exports.PlatformType = PlatformType = {}));
